module.exports = __webpack_public_path__ + "assets/img/tongdian1.2a2e5fbd.png";